import { useMemo } from "react"
import { ListGiftModel } from "src/types"
import "swiper/css"
import "swiper/css/grid"
import "swiper/css/navigation"
import { Autoplay, Grid, Navigation, Scrollbar } from "swiper/modules"
import { Swiper, SwiperProps, SwiperSlide } from "swiper/react"
import GiftBox from "../GiftBox"
import "./styles.css"

interface GiftBoxSliderProps {
  data: ListGiftModel[]
}

const GiftBoxSlider = ({ data = [] }: GiftBoxSliderProps) => {
  const config = useMemo(
    () =>
      ({
        modules: [Navigation, Grid, Autoplay, Scrollbar],
        loop: false,
        scrollbar: false,
        autoplay: {
          disableOnInteraction: false,
        },
        navigation: true,
        grid: {
          rows: 1,
          fill: "column",
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            grid: {
              rows: data.length % 2 === 0 ? 2 : 1,
            },
          },
          450: {
            slidesPerView: data.length >= 2 ? 2 : 1,
            grid: {
              rows: data.length > 2 ? 2 : 1,
            },
          },
          1024: {
            slidesPerView:
              data.length <= 3 ? data.length : data.length === 4 ? 2 : 3,
            grid: {
              rows: data.length <= 3 ? 1 : 2,
            },
          },
        },
      }) as SwiperProps,
    [data]
  )

  return (
    <Swiper {...config}>
      {data.map((x, o) => (
        <SwiperSlide key={`${x.Id}-${o.toString()}`}>
          <GiftBox data={x} />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default GiftBoxSlider
